import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Button,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import { gAPI_Messenger, API_Ingetration_Channels, postAPI_Update_Messengers_DisplayOrder, gAPI_Messengers_CategoryList } from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import no_menues from './../../../../../assets/no_menu.png';
import MessengerListItem from './components/MessengerListItem';
import AddNewMessenger from './components/AddNewMessenger';
import CategoryTag from './components/CategoryTag';
import IntlMessages from '../../../../../helpers/IntlMessages';
import TemplateMessengerButton from './components/TemplateMessengerButton';
import LanguageTabs from '../components/LanguageTabs/LanguageTabs';
import AddonsAndUpsells_image from '../../../../../assets/addons_and_upsells.png';
import guest_book_image from '../../../../../assets/guest_book_image.png';
import ReactDragListView from "react-drag-listview";
import { List, Typography } from "antd";
import "antd/dist/antd.css";

function Index({ propertyId, locale }) {
  const [selectedLanguage, setSelectedLanguage] = useState(locale);
  const [messengerList, setMessengerList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [orderBy, setOrderBy] = useState({ column: 'Title', label: 'Title' });
  const [search, setSearch] = useState('');
  const [isHostedPage, setIsHostedPage] = useState(false);
  const [allAddonCategoryData, setAllAddonCategoryData] = useState([]);
  const [allMembershipGroupData, setAllMembershipGroupData] = useState([]);
  const [isEditCategory, setIsEditCategory] = useState(false);
  const orderOptions = [
    { column: 'Title', label: 'Title' },
    { column: 'Type', label: 'Type' },
    { column: 'Response', label: 'Response' },
    { column: 'Status', label: 'Status' },
  ];
  useEffect(() => {
    LoadData(selectedLanguage);
    let body = {
      channels: ['ServiceStandAlonePage']
    };
    AxiosAPI({
      method: 'post',
      url: `${API_Ingetration_Channels}?group_id=${getGroupID()}`,
      data: body
    }).then((res) => {
      const serviceHostedPageIntegration = res.data.filter(
        (k) => k.channel === 'ServiceStandAlonePage' && k.properties !== undefined && k.properties.includes(propertyId)
      );
      if (serviceHostedPageIntegration.length > 0)
        setIsHostedPage(true);
    });
  }, [propertyId, orderBy, search]);

  const LoadData = (lang) => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Messenger}?propertyId=${propertyId}&groupId=${getGroupID()}&lang=${lang}&orderBy=${orderBy.column}&search=${search}`,
    })
      .then((res) => {
        let service = res.data.sort((a, b) => a.displayOrder - b.displayOrder);
        setMessengerList(service);

        let member = allMembershipGroupData;
        service.map((m) => {
          if (m.membershipGroup !== null && m.membershipGroup.length > 0)
            m.membershipGroup.map((n) => {
              if (member.filter((f) => f === n).length === 0)
                member.push(n);
            })
        }
        );
        setAllMembershipGroupData(member);
        setLoading(false);
      })
      .catch((err) => console.log('err', err));

    AxiosAPI({
      method: 'get',
      url: `${gAPI_Messengers_CategoryList}?groupId=${getGroupID()}&propertyId=${propertyId}`,
    }).then((res) => {
      setAllAddonCategoryData(res.data.filter(i => i.languageCode === lang));
    });
  };

  const setLanguage = (e) => {
    setLoading(true);
    var lan = e;
    if (e === "zh-TW") {
      lan = "hk";
    }
    setSelectedLanguage(lan);
    LoadData(lan);
    setLoading(false);
  }

  const toggleModal = () => {
    setVisible(!visible);
  };

  const changeOrderBy = (column) => {
    setOrderBy(orderOptions.find((x) => x.column === column));
  };

  const onSearchKey = (e) => {
    if (e.key === 'Enter') {
      setSearch(e.target.value.toLowerCase());
    }
  };

  if (loading) {
    return <div className="loading" />;
  }
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };

  const onDragEnd = (fromIndex, toIndex, type, index) => {
    if (toIndex < 0) return;
    if (type === "LIST-ITEM") {
      const categories = reorder(messengerList, fromIndex, toIndex);
      var data = [];
      categories.map((item, i) => {
        data.push({
          id: item.id,
          displayOrder: i
        })
      });
      AxiosAPI({
        method: 'post',
        url: `${postAPI_Update_Messengers_DisplayOrder}`,
        data: { data: data },
      }).then((res) => {
        return setMessengerList(categories);
      }).catch((err) => {
        console.log('err', err);
      });
    } else return new Error("NOT A VALID LIST");
  };
  return (
    <Fragment>
      <Row className="app-row survey-app">
        <Colxx xxs="12">
          <div className="mb-2">
            <h1><IntlMessages id="virtual-messenger" /></h1>
          </div>
          <div className="mb-2">
            <div className="d-block d-md-inline-block">
              <UncontrolledDropdown className="mr-1 float-md-left btn-group mb-1">
                <DropdownToggle caret color="outline-dark" size="xs">
                  <IntlMessages id="pages.orderby" />
                  {orderBy.label}
                </DropdownToggle>
                <DropdownMenu>
                  {orderOptions.map((order, index) => {
                    return (
                      <DropdownItem
                        key={index}
                        onClick={() => changeOrderBy(order.column)}
                      >
                        {order.label}
                      </DropdownItem>
                    );
                  })}
                </DropdownMenu>
              </UncontrolledDropdown>
              <div className="search-sm d-inline-block float-md-left mr-1 mb-1 align-top">
                <input
                  type="text"
                  name="keyword"
                  id="search"
                  placeholder="Search"
                  onKeyPress={(e) => onSearchKey(e)}
                />
              </div>
              {!loading && (
                <Fragment>
                  <Button
                    color="primary"
                    size="xs"
                    outline
                    className=" mr-1"
                    onClick={toggleModal}
                  >
                    + Add Menu
                  </Button>
                  {/* <Button
                    color="primary"
                    size="xs"
                    className=" mr-1"
                    onClick={() => setIsEditCategory(true)}
                  >{""}<IntlMessages id="survey.edit" /> <IntlMessages id="survey.category" />
                  </Button> */}
                  {/* <TemplateServiceButton LoadData={LoadData} isServiceOrder={false} /> */}
                </Fragment>
              )}
              <a href="/app/pages/propinfo/publish-ai">
                <Button
                  color="primary"
                  outline
                  className='ml-2'
                  size="xs"
                >
                  Publish AI
                </Button>
              </a>
            </div>
          </div>
        </Colxx>
        <Colxx xxs="12">
          <LanguageTabs
            selectedTab={selectedLanguage === "hk" ? "zh-TW" : selectedLanguage}
            setLanguage={setLanguage}
          ></LanguageTabs>
        </Colxx>
      </Row>
      {/* <Separator className="mb-5" /> */}
      {!loading ? (
        messengerList.length > 0 ?
          <ReactDragListView
            nodeSelector=".ant-list.draggable"
            lineClassName="dragLine"
            onDragEnd={(fromIndex, toIndex) =>
              onDragEnd(fromIndex, toIndex, "LIST-ITEM")
            }
          >
            {messengerList.map((elem, index) => (
              <List key={index} className="draggable">
                <div className="d-flex flex-row mb-3">
                  <span className="draggable item-center mb-3"><a href="#"><i className="simple-icon-cursor-move"></i></a></span>
                  <MessengerListItem
                    item={elem}
                    toggleModal={toggleModal}
                    isHostedPage={isHostedPage}
                    isServiceOrder={false}
                    allAddonCategoryData={allAddonCategoryData}
                    allMembershipGroupData={allMembershipGroupData}
                    LoadData={LoadData}
                    languageCode={selectedLanguage}
                  />
                </div>
              </List>
            ))}
          </ReactDragListView>
          : (
            <Fragment>
              <Colxx xxs="12" className="mb-0 text-center">
                <img className='w-25' style={{ marginTop: '5rem' }} src={no_menues}></img></Colxx>
              <Colxx xxs="12" className="mb-4 text-center">
                <Button
                  color="primary"
                  size="xs"
                  outline
                  className=" mr-1"
                  onClick={toggleModal}
                >
                  + Add Your First Menu
                </Button>

              </Colxx>
            </Fragment>
          )
      ) : (
        <div className="loading" />
      )}

      <AddNewMessenger
        toggleModal={toggleModal}
        formLabel="Create"
        visible={visible}
        allAddonCategoryData={allAddonCategoryData}
        allMembershipGroupData={allMembershipGroupData}
        LoadData={LoadData}
        languageCode={selectedLanguage}
      />
      {isEditCategory && (
        <CategoryTag
          visible={isEditCategory}
          toggle={() => setIsEditCategory(!isEditCategory)}
          allCategoryData={allAddonCategoryData}
          isEdit={isEditCategory}
          propertyId={propertyId}
          LoadData={LoadData}
          languageCode={selectedLanguage}
        ></CategoryTag>
      )}
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId, locale
  };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
